"use strict";

import getNgModule from "getNgModule";
import moment from "moment";
var ngModule = getNgModule(__filename);
ngModule.factory("dateUtils", function () {
  var dateUtils = {
    isBeginningOfYear: function isBeginningOfYear(date) {
      return moment(date).dayOfYear() === 1;
    },
    isEndOfYear: function isEndOfYear(date) {
      var momentDate = moment(date);
      return moment(date).date() === 31 && momentDate.month() === 11;
    }
  };
  return dateUtils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/dateUtils.js
// module id = 2747
// module chunks = 13